import { ChangeEvent, forwardRef } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  & label {
      font-weight: 400;
    width: 100%;
    background-color: #666666;
    color: #e6e6e6;
    margin-bottom: 12px;
    font-size: 16px;

    display: inline-block;
    padding: 4px 20px;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    touch-action: manipulation;
    cursor: pointer;
    border: none;
    border-radius: 20px;
    margin-bottom: 0; 

  & label:hover {
    color: rgba(29, 36, 47, 0.6);
    box-shadow: 2px 2px 10px #7d7b7b;
    background-color: #808080;
  }

  & input {
    display: none;
  }
`;

interface FileInputButtonProps {
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

const FileInputButton = forwardRef<HTMLInputElement, FileInputButtonProps>(
  ({ onChange }, ref) => {
    return (
      <Container>
        <label>
          Browse
          <input
            id="pdfFile"
            ref={ref}
            type="file"
            accept=".pdf"
            onChange={onChange}
          />
        </label>
      </Container>
    );
  }
);

export default FileInputButton;
